import {type Static, Type} from '@sinclair/typebox'
import {TypeCompiler} from '@sinclair/typebox/compiler'

import {type Product, transformProducts} from '@/models/productModel'

const rawHomePageSchema = Type.Object({
  title: Type.String(),
  message: Type.Optional(Type.String()),
  timestamp: Type.Optional(Type.Number()),
  products: Type.Array(Type.Unknown()), // To be validated later
})

export type RawHomePage = Static<typeof rawHomePageSchema>

const rawHomePageTypeCheck = TypeCompiler.Compile(rawHomePageSchema)

export type HomePage = {
  title: string
  products: Product[]
  message: string
  timestamp?: number
}[]

export function transformHomePage(homepage: unknown): HomePage {
  if (!homepage) return []
  if (typeof homepage !== 'object') return []

  return Object.values(homepage)
    .map(section => {
      if (!rawHomePageTypeCheck.Check(section)) return false

      return {
        title: section.title,
        products: transformProducts(section.products),
        message: section.message ?? '',
        timestamp: section.timestamp,
      }
    })
    .filter(Boolean)
}
